import ApiConnector from '@/backend/apiModels/userApi'
import ApiAdminConnector from '@/backend/apiModels/admin'
import { useRouter } from 'vue-router';
import {useErrorHandler} from '@/hooks/errorHandler';
import { createToaster } from "@meforma/vue-toaster";
import { useAxiosCreate } from '@/backend/utils.js';
import { translateDetail, translateFieldMessage } from '@/backend/errorMessages';
import { invalidateCarDetail, invalidateCarsQueries } from '@/queryClient'


function processActivities(activities) {
  const datasets = [];
  let date_datasets = []

  activities.forEach(activity=>{
    const dates = JSON.parse(activity.dates);
    const values = JSON.parse(activity.values);
    
    if(!dates) return null

    if(dates.length>date_datasets.length){
      date_datasets = dates
    }
    const dataset = {
      label: activity.title,
      data: values
    }

    datasets.push(dataset);
    
  })

  return {datasets,date_datasets}
}

const toaster = createToaster();
const api = new ApiConnector()
const apiOptions = new ApiAdminConnector()
const innApi = useAxiosCreate('drivers')
const namespaced = true
const OPTIONS_CACHE_KEY = 'erp:admin-options:v1'
const OPTIONS_CACHE_TTL_MS = 60 * 60 * 1000
let optionsRequest = null

function readOptionsCache() {
  try {
    const cached = JSON.parse(localStorage.getItem(OPTIONS_CACHE_KEY))
    if (!cached?.data || !cached?.savedAt) return null
    return cached
  } catch {
    return null
  }
}

function writeOptionsCache(data) {
  try {
    localStorage.setItem(OPTIONS_CACHE_KEY, JSON.stringify({
      savedAt: Date.now(),
      data,
    }))
  } catch {
    // ignore storage quota/private mode errors
  }
}

export function clearOptionsCache() {
  try {
    localStorage.removeItem(OPTIONS_CACHE_KEY)
  } catch {
    // ignore
  }
}

function optionsResponse(data) {
  return { value: data }
}

function getValidationErrors(error) {
  const detail = error?.response?.data?.detail
  if (!detail) return {}

  if (Array.isArray(detail)) {
    return detail.reduce((errors, item) => {
      const field = item.loc?.[item.loc.length - 1]
      if (field) {
        errors[field] = translateFieldMessage(item.msg)
      }
      return errors
    }, {})
  }

  if (typeof detail === 'string') return { _form: translateDetail(detail) }
  if (typeof detail === 'object' && detail.message) return { _form: translateDetail(detail) }
  return {}
}

const state = {
  admin:{
    isLoad:false,
    security:{},
    statusLoading:false
  },
  options:{
    isLoad:false,
    company:{},
    security:{},
    trip_status:[],
    tariffs:[],
    rates:[],
    payments:[],
    trip_city:[],
    payment_methods:[],
    managers:[],
    transport_type:[],
    statusLoading:false
  },
  search:{
    companies:[],
    cars:[],
    drivers:[],
    managers:[],
    trailers:[],
    executors:[],
  },
  drivers:{
    item:{},
    items:{},
    currentPage: 1,
    totalPages:1,
    statusLoading: false,
    formErrors: {},
  },
  companies:{
    item:{},
    items:{},
    dataset:{},
    currentPage: 1,
    totalPages:1,
    statusLoading: false,
  },
  managers:{
    item:{},
    items:{},
    currentPage: 1,
    totalPages:1,
    statusLoading: false,
  },
  cars:{
    item:{},
    items:{},
    currentPage: 1,
    totalPages:1,
    statusLoading: false,
  },
  executors:{
    item:{},
    items:{},
    currentPage: 1,
    totalPages:1,
    statusLoading: false,
  },
  customers:{
    item: null,
    items: [],
    currentPage: 1,
    totalPages: 1,
    statusLoading: false,
  },
  trips:{
    item:{},
    items:{},
    comments:[],
    currentPage: 1,
    totalPages:1,
    statusLoading: false,
  },
  topClients:{
    item: null,
    items: [],
    currentPage: 1,
    totalPages: 1,
    statusLoading: false,
  }
};

const mutations = {
  setSecuritiOptions(state,response){
    state.options.security = response
  },
  setComments(state, {model,response}){
    state[model].comments = response.value
  },

  setOptions(state, {model,response}){
    if(model==='security'){
      state.admin.security = response.value  
    }else{
      for (let key in response.value) {
        state.options[key] = response.value[key]
      }
    }
    state.options.isLoad = true
  },

  setCompanyActivity(state,response){
    state.companies.item.activities = response.value
  },

  setLoading(state, { model, status }) {
    if(model==='security'){
      state.admin.statusLoading = status;
    }else{
      state[model].statusLoading = status;  
    }
  },
  setFormErrors(state, { model, errors }) {
    if (state[model]) {
      state[model].formErrors = errors
    }
  },

  setDataItems(state, {model,response}) {
    if(model==='search'){
      state.search.companies = response.value.companies
      state.search.cars = response.value.cars
      state.search.drivers = response.value.drivers
      state.search.managers = response.value.managers
      state.search.executors = response.value.executors
    }else{
      state[model].currentPage = response.value.current_page
      state[model].totalPages = response.value.total_pages
      const items = response.value[model]
      state[model].items = Array.isArray(items) ? items : []
    }
  },
  setDataItem(state,{ model, response }){
    if(model.includes('/')){
      const modelPath = model.split('/')
      state[modelPath[0]][modelPath[1]] = status;
    }else{
      state[model].item = response.value
    }
    
  },
  setSettings(state,{ response }){
    state.settings.values = response.value
    if(state.settings.values) state.settings.isLoad = true
  },
  setSearch(state,{model,response}){
    state.search[model].push(response.value)
  },
};

const getters = {
  checkOptions(state){
    if(state.options.isLoad){
      return true;
    }
    return false;
  },
  getItems(state) {
    const page = state.currentPage;
    return state.items[page];
  },
  getDatasetsExecutor(state){
    const activities = state.executors.item.company.activities
    if (!activities) return null;
    return processActivities(activities);
  }, 

  getDatasets(state){
    const activities = state.companies.item.activities
    if(!activities) return null
    return processActivities(activities);
  }
};

const actions = {
  async startTimer({ dispatch },{model,params,type}){
    // Запускаем таймер на 30 секунд
      const timerDuration = 30000;
      setTimeout(() => {
        if(type === 'items'){
          dispatch('getItems',{model,params});  
        }else{
          dispatch('getItem',{model,params});
        }
      }, timerDuration);
  },

  async startLoading(ctx,{request,response,model}){
    ctx.commit('setLoading', {model,status:true})
    let path = null
    ctx.commit('setFormErrors', {model, errors: {}})
    try{
      await request()
    }catch(error){
      ctx.commit('setFormErrors', {model, errors: getValidationErrors(error)})
      path =  useErrorHandler(error)
      ctx.commit('setLoading', {model,status:false})
    }
    return path
  },

  async loadActivity(ctx,{model,params}){
    let url = model
    if (params.id){
      url = model+"/"+params.id
      params={}
    }
    const { response, request } = api.get(url,params)
    const path = await ctx.dispatch('startLoading',{request,response,model:'companies'})
    ctx.commit('setCompanyActivity',response)
    ctx.commit('setLoading', {model:'companies',status:false})
  },

  async addItem(ctx,{model,form}){
    const router = useRouter()
    const { response, request } = api.post(model,form)
    const path = await ctx.dispatch('startLoading',{request,response,model})
    ctx.commit('setLoading', {model,status:false})
    if(path) router.push(path)
    if(response.value){
      if (model === 'cars') {
        await invalidateCarsQueries()
      }
      if (response.value.created === false) {
        const labels = {
          cars: 'авто',
          companies: 'компанию',
          drivers: 'водителя',
          managers: 'менеджера',
          trailers: 'прицеп',
        }
        const label = labels[model] || 'запись'
        // Менеджеры могут быть привязаны к нескольким компаниям (CompanyManager m2m):
        //   linked === true  → только что привязан к текущей компании (раньше был у другой)
        //   linked === false → уже был привязан ранее (idempotent повторный запрос)
        if (model === 'managers' && response.value.linked === true) {
          toaster.info(`Менеджер уже существует, привязан к этой компании`)
        } else if (model === 'managers' && response.value.linked === false) {
          toaster.info(`Менеджер уже привязан к этой компании`)
        } else {
          toaster.info(`Выбрана существующая запись: ${label}`)
        }
      }
      return response.value
    }
    return null
  },

  async getItem(ctx,{model,params}){
    let url = model
    if (params.id){
      url = model+"/"+params.id
      params={}
    }
    const { response, request } = api.get(url,params)
    await ctx.dispatch('startLoading',{request,response,model})
    if (response.value) {
      ctx.commit('setDataItem', {model,response})
    }
    ctx.commit('setLoading', {model,status:false})
    return Boolean(response.value)
  },

  async getTmsItem(ctx,{model,params}){
    const { response, request } = api.getItems(model,params)
    await ctx.dispatch('startLoading',{request,response,model:'trips'})
    ctx.commit('setDataItem', {model:'trips',response})
    ctx.commit('setLoading', {model:'trips',status:false})
  },

  async getItems(ctx,{model,params}){
    const { response, request } = api.getItems(model,params)
    await ctx.dispatch('startLoading',{request,response,model})
    if(response.value){
      ctx.commit('setDataItems', {model,response})
    }
    ctx.commit('setLoading', {model,status:false})
    return Boolean(response.value)
  },

  async getFilteredList(ctx, {model, params}) {
    const { response, request } = api.getFilteredList(model, params)
    await ctx.dispatch('startLoading', {request, response, model})
    if (response.value) {
      ctx.commit('setDataItems', {model, response})
    }
    ctx.commit('setLoading', {model, status:false})
  },

  async deleteItem(ctx,{model,params}){
    const { response, request } = api.delete(model,params)
    await ctx.dispatch('startLoading',{request,response,model})
    ctx.commit('setLoading', {model,status:false})
    return Boolean(response?.value)
  },

  async getSettings(ctx){
    const { response, request } = api.getSettings()
    await ctx.dispatch('startLoading',{request,response,model:'settings'})
    ctx.commit('setSettings', {response})
    ctx.commit('setLoading', {model:'settings',status:false})
  },

  async getOptions(ctx,{model,params}){
    if (model === 'options') {
      const cached = readOptionsCache()
      if (cached?.data) {
        ctx.commit('setOptions', { model, response: optionsResponse(cached.data) })
      }

      const isFresh = cached && Date.now() - cached.savedAt < OPTIONS_CACHE_TTL_MS
      if (isFresh) return
      if (optionsRequest) return cached?.data ? undefined : optionsRequest

      optionsRequest = (async () => {
        const { response, request } = apiOptions.get({model,params})
        try {
          await ctx.dispatch('startLoading',{request,response,model})
          if (response.value) {
            ctx.commit('setOptions', {model,response})
            writeOptionsCache(response.value)
          }
        } finally {
          ctx.commit('setLoading', {model,status:false})
          optionsRequest = null
        }
      })()

      return cached?.data ? undefined : optionsRequest
    }

    const { response, request } = apiOptions.get({model,params})
    if(model !== 'security' && ctx.state.options.isLoad){
      return
    }
    await ctx.dispatch('startLoading',{request,response,model})
    ctx.commit('setOptions', {model,response})
    ctx.commit('setLoading', {model,status:false})
  },

  async updateOptions(ctx,{model,form}){
    const { response, request } = apiOptions.put({model,form})
    await ctx.dispatch('startLoading',{request,response,model})
    ctx.commit('setOptions', {model,response})
    ctx.commit('setLoading', {model,status:false})
    if(response) toaster.success("Данные обновлены");
  },

  async getFilterItems(ctx,{model,form}){
    const { response, request } = api.post(model+'/search',form)
    await ctx.dispatch('startLoading',{request,response,model})
    if(response.value){
      ctx.commit('setDataItems', {model,response})
    }
    ctx.commit('setLoading', {model,status:false})  
  },

  async updateItem(ctx,{model,form}){
    const { response, request } = api.put(model,form)
    await ctx.dispatch('startLoading',{request,response,model})
    if (response?.value) {
      ctx.commit('setDataItem', {model,response})
      toaster.success("Данные обновлены");
      if (model === 'cars') {
        await invalidateCarDetail(form?.id || response.value?.id)
      }
    }
    ctx.commit('setLoading', {model,status:false})
    return response?.value || null
  },

  async searchOnServer(ctx,{model,params}){
    const { response, request } = api.getByParam(model,params)
    await ctx.dispatch('startLoading',{request,response,model})
    ctx.commit('setSearch', {model,response})
    ctx.commit('setLoading', {model,status:false})
    if (!response.value) return false
    return true
  },

  async executorSearch(ctx,{link,form}){
    const { response, request } = api.post(link,form)

    const model = 'executors'
    await ctx.dispatch('startLoading',{request,response,model})
    if(response.value){
      ctx.commit('setDataItems', {model,response})
    }
    ctx.commit('setLoading', {model,status:false})  
  },

  async addComment(ctx,{model,form}){
    const { response, request } = api.post('comment/'+model,form)
    await request()
    ctx.dispatch('getComment',{model,params:{trip_id:form.trip_id}})
  },

  async getComment(ctx,{model,params}){
    const { response, request } = api.getItems('comment/'+model,params)
    await request()
    if(response.value){
      ctx.commit('setComments', {model,response})
    }
  },

  async addTripTemlate(ctx,{model,form}){
    const { response, request } = api.put(model+'/template',form)
    await request()
    if(response.value){
      ctx.commit('setDataItems', {model,response})
    }
  },

  async loadOptions(ctx){
    
    const { response, request } = api.getItems('/security-options',{})
    await request()
    if(response.value){
      ctx.commit('setSecuritiOptions', response.value)
    }
  },

  async getInnStatus(ctx, { id }) {
    const { data } = await innApi.get(`${id}/inn-status`)
    return data
  },

  async recheckInn(ctx, { id }) {
    const { data } = await innApi.post(`${id}/recheck-inn`)
    return data
  },

  async pollInnStatus({ dispatch }, {
    id,
    onUpdate,
    maxTotalMs = 900000,
    initialDelayMs = 2000,
    capDelayMs = 30000,
    growthFactor = 1.5,
  } = {}) {
    const startedAt = Date.now()
    let delayMs = initialDelayMs
    while (Date.now() - startedAt < maxTotalMs) {
      await new Promise(resolve => setTimeout(resolve, delayMs))
      let status
      try {
        status = await dispatch('getInnStatus', { id })
      } catch (e) {
        delayMs = Math.min(capDelayMs, delayMs * growthFactor)
        continue
      }
      if (status && ['done', 'failed'].includes(status.inn_check_status)) {
        if (typeof onUpdate === 'function') onUpdate(status)
        return
      }
      delayMs = Math.min(capDelayMs, delayMs * growthFactor)
    }
  },
};


export default {
  state,
  mutations,
  getters,
  actions,
  namespaced
};
